export default __webpack_public_path__ + "static/media/askchristee-logo.f80365ed.svg";